import { gql } from "@apollo/client";

export const getSpectaclesTags = gql`
    query spectaclesTags {
        spectaclesTags
    }
`;
